// extracted by mini-css-extract-plugin
export var articleListWrapper = "index-module--article-list-wrapper--wnYRH";
export var headingWrapper = "index-module--heading-wrapper--bCUmP";
export var main = "index-module--main--ZFcCl";
export var mainHeadingWrapper = "index-module--main-heading-wrapper--CYRIx";
export var nav = "index-module--nav---Yd-V";
export var paginationWrapper = "index-module--pagination-wrapper--SarqF";
export var section = "index-module--section--YobWB";
export var totalBadgeWrapper = "index-module--total-badge-wrapper--PYJrS";